import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import api from '../../../../../../services/api';
import NavBarGestao from '../../../../../../components/NavBarGestao';

import {
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
  Divider,
  FormControlLabel,
  Checkbox,
  Switch,
  ButtonGroup
} from '@material-ui/core';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import SearchIcon from '@mui/icons-material/Search';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableViewIcon from '@mui/icons-material/TableView';
import ViewListIcon from '@mui/icons-material/ViewList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function AuditoriaDetalhe() {
  const { id } = useParams();
  const history = useHistory();

  const [auditoria, setAuditoria] = useState(null);
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [finalizing, setFinalizing] = useState(false);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });
  const [expandedItems, setExpandedItems] = useState({});
  const [busca, setBusca] = useState('');
  const [openFinalizarDialog, setOpenFinalizarDialog] = useState(false);
  const [selectedRvModal, setSelectedRvModal] = useState(null);
  const [visaoModo, setVisaoModo] = useState('completa'); // 'completa' | 'simplificada'

  const token = Cookies.get('token');
  const usuarioLogado = Cookies.get('usuario') ? JSON.parse(Cookies.get('usuario')) : null;
  const userId = Cookies.get('id_usuario') || (usuarioLogado ? usuarioLogado.id_usuario || usuarioLogado.id : null);

  const fetchAuditoria = async () => {
    setLoading(true);
    setMensagem({ tipo: '', texto: '' });
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get(`/v1/protected/auditoriamonitoramento/${id}`, { headers });
      const data = response.data;
      setAuditoria(data);
      if (data && data.itens) {
        setItens(data.itens);
        const initialExpanded = {};
        data.itens.forEach(item => {
          initialExpanded[item.id_item] = true;
        });
        setExpandedItems(initialExpanded);
      }
    } catch (err) {
      console.error('Erro ao carregar detalhes da auditoria:', err);
      setMensagem({ tipo: 'erro', texto: 'Erro ao carregar dados da auditoria.' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAuditoria();
    }
  }, [id]);

  const handleFieldChange = (id_item, field, value) => {
    if (auditoria && auditoria.status === 1) return;
    setItens(prev =>
      prev.map(item => (item.id_item === id_item ? { ...item, [field]: value } : item))
    );
  };

  const handleCheckboxChange = (id_item, field, checked) => {
    if (auditoria && auditoria.status === 1) return;
    setItens(prev =>
      prev.map(item => (item.id_item === id_item ? { ...item, [field]: checked ? 1 : 0 } : item))
    );
  };

  const handleExpandAll = () => {
    const newExpanded = {};
    itens.forEach(item => {
      newExpanded[item.id_item] = true;
    });
    setExpandedItems(newExpanded);
  };

  const handleCollapseAll = () => {
    setExpandedItems({});
  };

  const toggleAccordion = (id_item) => {
    setExpandedItems(prev => ({ ...prev, [id_item]: !prev[id_item] }));
  };

  const handleSalvarAlteracoes = async () => {
    if (saving || finalizing || (auditoria && auditoria.status === 1)) return;
    setSaving(true);
    setMensagem({ tipo: '', texto: '' });
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(
        `/v1/protected/auditoriamonitoramento/atualizar/${id}/${userId}`,
        itens,
        { headers }
      );
      if (response.data) {
        setAuditoria(response.data);
        if (response.data.itens) {
          setItens(response.data.itens);
        }
        setMensagem({ tipo: 'sucesso', texto: 'Alterações salvas com sucesso!' });
      }
    } catch (err) {
      console.error('Erro ao salvar alterações:', err);
      setMensagem({ tipo: 'erro', texto: 'Erro ao salvar alterações na auditoria.' });
    } finally {
      setSaving(false);
    }
  };

  const handleFinalizarAuditoria = async () => {
    setOpenFinalizarDialog(false);
    if (finalizing || (auditoria && auditoria.status === 1)) return;
    setFinalizing(true);
    setMensagem({ tipo: '', texto: '' });
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(
        `/v1/protected/auditoriamonitoramento/finalizar/${id}/${userId}`,
        {},
        { headers }
      );
      if (response.data) {
        setAuditoria(response.data);
        if (response.data.itens) {
          setItens(response.data.itens);
        }
        setMensagem({ tipo: 'sucesso', texto: 'Auditoria finalizada com sucesso! Não é mais possível editá-la.' });
      }
    } catch (err) {
      console.error('Erro ao finalizar auditoria:', err);
      setMensagem({ tipo: 'erro', texto: 'Erro ao finalizar a auditoria.' });
    } finally {
      setFinalizing(false);
    }
  };

  const filteredItens = itens.filter(item => {
    if (!busca) return true;
    const term = busca.toLowerCase();
    return (
      (item.nome_instalacao && item.nome_instalacao.toLowerCase().includes(term)) ||
      (item.identificador_integrador && String(item.identificador_integrador).includes(term)) ||
      (item.status_geral_instalacao && item.status_geral_instalacao.toLowerCase().includes(term)) ||
      (item.detalhes_pgm_centrais && item.detalhes_pgm_centrais.toLowerCase().includes(term)) ||
      (item.observacao_pgm && item.observacao_pgm.toLowerCase().includes(term)) ||
      (item.observacao_corneta && item.observacao_corneta.toLowerCase().includes(term)) ||
      (item.observacao_geral && item.observacao_geral.toLowerCase().includes(term)) ||
      (item.resolutiva && item.resolutiva.toLowerCase().includes(term))
    );
  });

  const isFinalizada = auditoria && auditoria.status === 1;
  const canEdit = !isFinalizada;

  // Cálculo dos contadores do dashboard resumo
  const totalLocalidades = itens.length;
  const totalOnlineComConexao = itens.filter(i => i.status_geral_instalacao === 'Online com Conexão' || i.status_geral_instalacao === 'Online').length;
  const totalOnlineSemConexao = itens.filter(i => i.status_geral_instalacao === 'Online sem Conexão').length;
  const totalOffline = itens.filter(i => i.status_geral_instalacao === 'Totalmente Offline' || i.status_geral_instalacao === 'Offline' || i.status_geral_instalacao === 'Em Alarme').length;

  const getStatusStyle = (statusGeral) => {
    if (statusGeral === 'Em Alarme') {
      return {
        bgColor: '#fbe9e7',
        borderColor: '#d84315',
        chipBg: '#ffebee',
        chipColor: '#c62828',
        label: 'Em Alarme'
      };
    }
    if (statusGeral === 'Online com Conexão' || statusGeral === 'Online') {
      return {
        bgColor: '#f1f8e9',
        borderColor: '#4caf50',
        chipBg: '#e8f5e9',
        chipColor: '#2e7d32',
        label: 'Online (Com Conexão Central)'
      };
    }
    if (statusGeral === 'Online sem Conexão') {
      return {
        bgColor: '#fffde7',
        borderColor: '#fbc02d',
        chipBg: '#fff8e1',
        chipColor: '#f57f17',
        label: 'Online (Sem Conexão Central)'
      };
    }
    return {
      bgColor: '#ffebee',
      borderColor: '#ef5350',
      chipBg: '#eeeeee',
      chipColor: '#b71c1c',
      label: 'Totalmente Offline'
    };
  };

  // Extrair código das PGMs / Unifiers de detalhes_pgm_centrais
  const getCodigosPgmStr = (rawText) => {
    if (!rawText) return '-';
    const matches = rawText.match(/=== (PGM Código:|Módulo Sonoro \/ Unifier Código:)\s*([^\n=]+) ===/g);
    if (!matches || matches.length === 0) return '-';
    return matches.map(m => m.replace(/=== (PGM Código:|Módulo Sonoro \/ Unifier Código:)\s*/, '').replace(/\s*===/, '').trim()).join(', ');
  };

  // Extrair última vez online de detalhes_pgm_centrais
  const getUltimaVezOnlineStr = (rawText) => {
    if (!rawText) return 'Sem informação';
    const lines = rawText.split('\n');
    for (let l of lines) {
      if (l.includes('• Status PGM:') || l.includes('• Status Módulo Sonoro:')) {
        const parts = l.split(':');
        if (parts.length > 1) return parts.slice(1).join(':').trim();
      }
    }
    return 'Sem informação';
  };

  // Exportação da tabela simplificada para Excel (.xlsx)
  const handleExportExcel = () => {
    const criadorNome = auditoria && auditoria.usuario_criador ? auditoria.usuario_criador.nome_amigavel : 'Sistema';
    const dataCriacao = auditoria ? auditoria.data_criacao || '' : '';
    const agoraStr = new Date().toLocaleString('pt-BR');

    const excelData = [
      ['AUDITORIA DE MONITORAMENTO DE INSTALAÇÕES'],
      ['Título:', auditoria ? auditoria.titulo : ''],
      ['Gerado Por:', criadorNome],
      ['Data de Criação:', dataCriacao],
      ['Data de Exportação:', agoraStr],
      [''],
      ['Localidade', 'ID SIGMA', 'Código PGM / Unifier', 'Última Vez Online', 'Status Geral', 'Intervenção Presencial']
    ];

    filteredItens.forEach(item => {
      excelData.push([
        item.nome_instalacao || '',
        item.identificador_integrador || '',
        getCodigosPgmStr(item.detalhes_pgm_centrais),
        getUltimaVezOnlineStr(item.detalhes_pgm_centrais),
        item.status_geral_instalacao || '',
        item.precisa_intervencao === 1 ? 'SIM' : 'NÃO'
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Auditoria Simplificada');
    XLSX.writeFile(workbook, `Auditoria_Monitoramento_${id}.xlsx`);
  };

  // Exportação da tabela simplificada para PDF com cabeçalho
  const handleExportPDF = () => {
    const doc = new jsPDF('landscape');
    const criadorNome = auditoria && auditoria.usuario_criador ? auditoria.usuario_criador.nome_amigavel : 'Sistema';
    const dataCriacao = auditoria ? auditoria.data_criacao || '' : '';
    const agoraStr = new Date().toLocaleString('pt-BR');

    doc.setFontSize(16);
    doc.setTextColor(26, 35, 126); // Blue
    doc.text(auditoria ? auditoria.titulo : 'Auditoria de Monitoramento', 14, 15);

    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    doc.text(`Criado por: ${criadorNome} | Data Criação: ${dataCriacao} | Exportado em: ${agoraStr}`, 14, 22);

    const tableRows = filteredItens.map(item => [
      item.nome_instalacao || '',
      String(item.identificador_integrador || ''),
      getCodigosPgmStr(item.detalhes_pgm_centrais),
      getUltimaVezOnlineStr(item.detalhes_pgm_centrais),
      item.status_geral_instalacao || '',
      item.precisa_intervencao === 1 ? 'SIM' : 'NÃO'
    ]);

    autoTable(doc, {
      startY: 28,
      head: [['Localidade', 'ID SIGMA', 'Código PGM / Unifier', 'Última Vez Online', 'Status Geral', 'Intervenção Presencial']],
      body: tableRows,
      theme: 'grid',
      headStyles: { fillColor: [25, 118, 210], textColor: 255, fontStyle: 'bold' },
      didParseCell: (data) => {
        if (data.section === 'body' && data.column.index === 4) {
          const val = data.cell.raw;
          if (val === 'Online com Conexão' || val === 'Online') {
            data.cell.styles.fillColor = [232, 245, 233];
            data.cell.styles.textColor = [46, 125, 50];
            data.cell.styles.fontStyle = 'bold';
          } else if (val === 'Online sem Conexão') {
            data.cell.styles.fillColor = [255, 248, 225];
            data.cell.styles.textColor = [245, 127, 23];
            data.cell.styles.fontStyle = 'bold';
          } else {
            data.cell.styles.fillColor = [255, 235, 238];
            data.cell.styles.textColor = [198, 40, 40];
            data.cell.styles.fontStyle = 'bold';
          }
        }
        if (data.section === 'body' && data.column.index === 5) {
          if (data.cell.raw === 'SIM') {
            data.cell.styles.textColor = [198, 40, 40];
            data.cell.styles.fontStyle = 'bold';
          } else {
            data.cell.styles.textColor = [46, 125, 50];
          }
        }
      }
    });

    doc.save(`Auditoria_Monitoramento_${id}.pdf`);
  };

  // Renderizador visual estruturado dos detalhes de PGM, Centrais e Zonas
  const renderDetalhesPgmCentrais = (rawText) => {
    if (!rawText) return <Typography variant="body2" color="textSecondary">Sem informações.</Typography>;

    const lines = rawText.split('\n').map(l => l.trim()).filter(Boolean);
    const blocks = [];
    let currentBlock = null;

    lines.forEach(line => {
      if (line.startsWith('=== PGM Código:') || line.startsWith('=== Módulo Sonoro')) {
        if (currentBlock) blocks.push(currentBlock);
        const isSonoro = line.includes('Módulo Sonoro');
        currentBlock = {
          type: isSonoro ? 'SONORO' : 'PGM',
          codigo: line.replace(/=== (PGM Código:|Módulo Sonoro \/ Unifier Código:)\s*/, '').replace(/\s*===/, ''),
          ipPgm: '',
          ipCentral: '',
          ipCorneta: '',
          statusPgm: '',
          statusParticoes: '',
          statusZonas: ''
        };
      } else if (line.startsWith('=== Outros Equipamentos ===')) {
        if (currentBlock) blocks.push(currentBlock);
        currentBlock = { type: 'EQUIPAMENTOS', items: [] };
      } else if (currentBlock && (currentBlock.type === 'PGM' || currentBlock.type === 'SONORO')) {
        if (line.includes('• IP PGM:')) currentBlock.ipPgm = line.replace('• IP PGM:', '').trim();
        else if (line.includes('• IP Central Configurada:')) currentBlock.ipCentral = line.replace('• IP Central Configurada:', '').trim();
        else if (line.includes('• IP Corneta PGM:')) currentBlock.ipCorneta = line.replace('• IP Corneta PGM:', '').trim();
        else if (line.includes('• Status PGM:')) currentBlock.statusPgm = line.replace('• Status PGM:', '').trim();
        else if (line.includes('• Status Módulo Sonoro:')) currentBlock.statusPgm = line.replace('• Status Módulo Sonoro:', '').trim();
        else if (line.includes('• Status Partições (Central):')) currentBlock.statusParticoes = line.replace('• Status Partições (Central):', '').trim();
        else if (line.includes('• Status Zonas:')) currentBlock.statusZonas = line.replace('• Status Zonas:', '').trim();
      } else if (currentBlock && currentBlock.type === 'EQUIPAMENTOS') {
        currentBlock.items.push(line);
      }
    });
    if (currentBlock) blocks.push(currentBlock);

    if (blocks.length === 0) {
      return (
        <Paper style={{ padding: '10px 12px', backgroundColor: '#fff', fontSize: '13px', whiteSpace: 'pre-wrap' }}>
          {rawText}
        </Paper>
      );
    }

    return (
      <Box display="flex" flexDirection="column" gap={2} marginTop={1}>
        {blocks.map((blk, idx) => {
          if (blk.type === 'PGM' || blk.type === 'SONORO') {
            const isOnline = blk.statusPgm.toLowerCase().includes('online');
            const titleLabel = blk.type === 'SONORO' ? `📢 Módulo Sonoro / Unifier Código: ${blk.codigo}` : `📟 Módulo PGM Código: ${blk.codigo}`;
            const chipLabel = blk.type === 'SONORO' ? (isOnline ? 'Unifier Online' : 'Unifier Offline') : (isOnline ? 'PGM Online' : 'PGM Offline');
            return (
              <Paper key={idx} elevation={1} style={{ padding: '14px', borderLeft: isOnline ? '5px solid #4caf50' : '5px solid #9e9e9e', backgroundColor: '#fff', borderRadius: 8 }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1.5}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                    {titleLabel}
                  </Typography>
                  <Chip
                    label={chipLabel}
                    size="small"
                    style={{ backgroundColor: isOnline ? '#e8f5e9' : '#eeeeee', color: isOnline ? '#2e7d32' : '#616161', fontWeight: 'bold' }}
                  />
                </Box>

                <Grid container spacing={1.5} style={{ fontSize: '13px', marginBottom: 12 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>IP PGM:</Typography>
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>{blk.ipPgm || 'Sem IP'}</Typography>
                  </Grid>
                  {blk.ipCentral && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>IP Central Configurada:</Typography>
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>{blk.ipCentral}</Typography>
                    </Grid>
                  )}
                  {blk.ipCorneta && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>IP Corneta PGM:</Typography>
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>{blk.ipCorneta}</Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>Status & Tempo Relativo PGM:</Typography>
                    <Typography variant="body2" style={{ color: isOnline ? '#2e7d32' : '#c62828', fontWeight: 'bold' }}>
                      {blk.statusPgm}
                    </Typography>
                  </Grid>
                </Grid>

                {/* Seção Separada: Status das Partições (Central) */}
                <Paper style={{ padding: '10px 12px', backgroundColor: '#f0f4f8', marginBottom: 8, borderRadius: 6, borderLeft: '4px solid #1976d2' }}>
                  <Typography variant="caption" style={{ fontWeight: 'bold', color: '#0d47a1', display: 'block', marginBottom: 2 }}>
                    🛡️ STATUS DAS PARTIÇÕES / ÁREAS (CENTRAL DE ALARME):
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 'bold', color: '#263238' }}>
                    {blk.statusParticoes || 'Sem status / Vazio'}
                  </Typography>
                </Paper>

                {/* Seção Separada: Status das Zonas (Central) */}
                <Paper style={{ padding: '10px 12px', backgroundColor: '#fff3e0', borderRadius: 6, borderLeft: '4px solid #ff9800' }}>
                  <Typography variant="caption" style={{ fontWeight: 'bold', color: '#e65100', display: 'block', marginBottom: 2 }}>
                    🚨 STATUS DAS ZONAS (CENTRAL DE ALARME):
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 'bold', color: '#263238' }}>
                    {blk.statusZonas || 'Sem status / Vazio'}
                  </Typography>
                </Paper>
              </Paper>
            );
          }

          if (blk.type === 'EQUIPAMENTOS' && blk.items.length > 0) {
            return (
              <Paper key={idx} style={{ padding: '12px', backgroundColor: '#f5f5f5', borderRadius: 8, borderLeft: '4px solid #607d8b' }}>
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#37474f', marginBottom: 6 }}>
                  📟 OUTROS EQUIPAMENTOS VINCULADOS
                </Typography>
                {blk.items.map((it, i) => (
                  <Typography key={i} variant="body2" style={{ fontFamily: 'monospace', fontSize: '12px', marginBottom: 2 }}>
                    • {it}
                  </Typography>
                ))}
              </Paper>
            );
          }

          return null;
        })}
      </Box>
    );
  };

  return (
    <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh', paddingBottom: '60px' }}>
      <NavBarGestao Monitoramento={true} MonitoramentoAuditoria={true} />

      <Container maxWidth="xl" style={{ marginTop: '24px' }}>
        {loading ? (
          <Paper style={{ padding: '48px', textAlign: 'center', borderRadius: '12px' }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: '16px' }}>
              Carregando dados da auditoria #{id}...
            </Typography>
          </Paper>
        ) : !auditoria ? (
          <Paper style={{ padding: '32px', textAlign: 'center', borderRadius: '12px' }}>
            <Typography variant="h6" color="error">
              Auditoria não encontrada.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: '16px' }}
              onClick={() => history.push('/tecnica/monitoramento/auditoria')}
            >
              Voltar para Lista
            </Button>
          </Paper>
        ) : (
          <>
            {/* Cabeçalho de Ações Principais */}
            <Paper style={{ padding: '20px 24px', borderRadius: '12px', marginBottom: '20px' }}>
              <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box display="flex" alignItems="center">
                    <IconButton onClick={() => history.push('/tecnica/monitoramento/auditoria')} style={{ marginRight: 8 }}>
                      <ArrowBackIcon />
                    </IconButton>
                    <div>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h5" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                          {auditoria.titulo}
                        </Typography>
                        {isFinalizada ? (
                          <Chip icon={<LockIcon />} label="Finalizada (Bloqueada)" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' }} />
                        ) : (
                          <Chip label="Em Andamento" style={{ backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 'bold' }} />
                        )}
                      </Box>
                      <Typography variant="caption" color="textSecondary">
                        Criada por: <b>{auditoria.usuario_criador ? auditoria.usuario_criador.nome_amigavel : 'Sistema'}</b> | Data: {auditoria.data_criacao || '-'}
                        {isFinalizada && ` | Finalizada em: ${auditoria.data_finalizacao}`}
                      </Typography>
                    </div>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6} align="right">
                  <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                    {/* Botões de Seleção de Visão */}
                    <ButtonGroup variant="contained" size="small">
                      <Button
                        style={{ backgroundColor: visaoModo === 'completa' ? '#1976d2' : '#e0e0e0', color: visaoModo === 'completa' ? '#fff' : '#424242' }}
                        onClick={() => setVisaoModo('completa')}
                        startIcon={<ViewListIcon />}
                      >
                        Visão Completa
                      </Button>
                      <Button
                        style={{ backgroundColor: visaoModo === 'simplificada' ? '#1976d2' : '#e0e0e0', color: visaoModo === 'simplificada' ? '#fff' : '#424242' }}
                        onClick={() => setVisaoModo('simplificada')}
                        startIcon={<TableViewIcon />}
                      >
                        Visão Simplificada
                      </Button>
                    </ButtonGroup>

                    <Button
                      variant="outlined"
                      onClick={() => history.push('/tecnica/monitoramento/auditoria')}
                      startIcon={<ArrowBackIcon />}
                    >
                      Voltar
                    </Button>

                    {canEdit && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSalvarAlteracoes}
                          disabled={saving || finalizing}
                          startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                          style={{ backgroundColor: '#1976d2' }}
                        >
                          {saving ? 'Salvando...' : 'Salvar Alterações'}
                        </Button>

                        <Button
                          variant="contained"
                          onClick={() => setOpenFinalizarDialog(true)}
                          disabled={saving || finalizing}
                          startIcon={finalizing ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
                          style={{ backgroundColor: '#2e7d32', color: '#fff' }}
                        >
                          {finalizing ? 'Finalizando...' : 'Finalizar Auditoria'}
                        </Button>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Paper>

            {mensagem.texto && (
              <Paper
                style={{
                  padding: '16px',
                  marginBottom: '20px',
                  backgroundColor: mensagem.tipo === 'sucesso' ? '#e8f5e9' : '#ffebee',
                  color: mensagem.tipo === 'sucesso' ? '#2e7d32' : '#c62828',
                  fontWeight: 'bold'
                }}
              >
                {mensagem.texto}
              </Paper>
            )}

            {/* Dashboard Resumo das Localidades */}
            <Grid container spacing={2} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={3}>
                <Card style={{ borderTop: '5px solid #1976d2' }}>
                  <CardContent style={{ padding: '16px', textAlign: 'center' }}>
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 'bold' }}>LOCALIDADES</Typography>
                    <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1a237e' }}>{totalLocalidades}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card style={{ borderTop: '5px solid #4caf50' }}>
                  <CardContent style={{ padding: '16px', textAlign: 'center' }}>
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 'bold' }}>ONLINE (C/ CONEXÃO)</Typography>
                    <Typography variant="h4" style={{ fontWeight: 'bold', color: '#2e7d32' }}>{totalOnlineComConexao}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card style={{ borderTop: '5px solid #ff9800' }}>
                  <CardContent style={{ padding: '16px', textAlign: 'center' }}>
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 'bold' }}>ONLINE (S/ CONEXÃO)</Typography>
                    <Typography variant="h4" style={{ fontWeight: 'bold', color: '#e65100' }}>{totalOnlineSemConexao}</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card style={{ borderTop: '5px solid #f44336' }}>
                  <CardContent style={{ padding: '16px', textAlign: 'center' }}>
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 'bold' }}>TOTALMENTE OFFLINE</Typography>
                    <Typography variant="h4" style={{ fontWeight: 'bold', color: '#c62828' }}>{totalOffline}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Barra de Busca e Filtros */}
            <Paper style={{ padding: '16px', borderRadius: '12px', marginBottom: '20px' }}>
              <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Buscar por localidade, ID SIGMA, IP, ramal ou observação..."
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                    InputProps={{
                      startAdornment: <SearchIcon style={{ color: '#757575', marginRight: 8 }} />
                    }}
                  />
                </Grid>

                {visaoModo === 'completa' ? (
                  <Grid item xs={12} sm={6} align="right">
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                      <Button size="small" variant="outlined" onClick={handleExpandAll} startIcon={<UnfoldMoreIcon />}>
                        Expandir Todos
                      </Button>
                      <Button size="small" variant="outlined" onClick={handleCollapseAll} startIcon={<UnfoldLessIcon />}>
                        Recolher Todos
                      </Button>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} align="right">
                    <Box display="flex" justifyContent="flex-end" gap={1}>
                      <Button
                        size="small"
                        variant="contained"
                        style={{ backgroundColor: '#2e7d32', color: '#fff' }}
                        onClick={handleExportExcel}
                        startIcon={<FileDownloadIcon />}
                      >
                        Exportar Excel (.xlsx)
                      </Button>
                      <Button
                        size="small"
                        variant="contained"
                        style={{ backgroundColor: '#c62828', color: '#fff' }}
                        onClick={handleExportPDF}
                        startIcon={<PictureAsPdfIcon />}
                      >
                        Exportar PDF
                      </Button>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* CONTEÚDO PRINCIPAL: VISÃO COMPLETA VS VISÃO SIMPLIFICADA */}
            {visaoModo === 'simplificada' ? (
              /* TABELA DA VISÃO SIMPLIFICADA */
              <Paper style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #e0e0e0' }}>
                <Box padding={2} backgroundColor="#f5f5f5" borderBottom="1px solid #e0e0e0">
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                    📋 VISÃO SIMPLIFICADA DA AUDITORIA ({filteredItens.length} localidades)
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Criado por: <b>{auditoria.usuario_criador ? auditoria.usuario_criador.nome_amigavel : 'Sistema'}</b> | Data da Auditoria: {auditoria.data_criacao || '-'}
                  </Typography>
                </Box>

                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#1976d2', color: '#fff' }}>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0' }}>LOCALIDADE</th>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0' }}>ID SIGMA</th>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0' }}>CÓDIGO PGM / UNIFIER</th>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0' }}>ÚLTIMA VEZ ONLINE</th>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0' }}>STATUS GERAL</th>
                        <th style={{ padding: '12px 16px', borderBottom: '2px solid #1565c0', textAlign: 'center' }}>INTERVENÇÃO PRESENCIAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredItens.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ padding: '24px', textAlign: 'center', color: '#757575' }}>
                            Nenhuma localidade encontrada com os filtros digitados.
                          </td>
                        </tr>
                      ) : (
                        filteredItens.map((item, idx) => {
                          const styleInfo = getStatusStyle(item.status_geral_instalacao);
                          const isEven = idx % 2 === 0;
                          return (
                            <tr
                              key={item.id_item}
                              style={{
                                backgroundColor: isEven ? '#ffffff' : '#f9f9f9',
                                borderBottom: '1px solid #e0e0e0'
                              }}
                            >
                              <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#1a237e' }}>
                                {item.nome_instalacao}
                              </td>
                              <td style={{ padding: '12px 16px' }}>
                                <Chip label={item.identificador_integrador || 'N/A'} size="small" style={{ backgroundColor: '#e3f2fd', color: '#1565c0', fontWeight: 'bold' }} />
                              </td>
                              <td style={{ padding: '12px 16px', fontFamily: 'monospace', fontWeight: 'bold' }}>
                                {getCodigosPgmStr(item.detalhes_pgm_centrais)}
                              </td>
                              <td style={{ padding: '12px 16px', color: '#424242' }}>
                                {getUltimaVezOnlineStr(item.detalhes_pgm_centrais)}
                              </td>
                              <td style={{ padding: '12px 16px' }}>
                                <Chip
                                  label={item.status_geral_instalacao}
                                  size="small"
                                  style={{ backgroundColor: styleInfo.chipBg, color: styleInfo.chipColor, fontWeight: 'bold' }}
                                />
                              </td>
                              <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={item.precisa_intervencao === 1}
                                      onChange={(e) => handleCheckboxChange(item.id_item, 'precisa_intervencao', e.target.checked)}
                                      color="secondary"
                                      disabled={!canEdit}
                                      size="small"
                                    />
                                  }
                                  label={
                                    <span style={{ fontWeight: 'bold', color: item.precisa_intervencao === 1 ? '#c62828' : '#2e7d32' }}>
                                      {item.precisa_intervencao === 1 ? 'SIM' : 'NÃO'}
                                    </span>
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </Paper>
            ) : (
              /* VISÃO COMPLETA (ÁRVORE E DETALHES DE ACCORDION) */
              <div>
                {filteredItens.length === 0 ? (
                  <Paper style={{ padding: '32px', textAlign: 'center', borderRadius: '12px' }}>
                    <Typography variant="body1" color="textSecondary">
                      Nenhuma localidade encontrada com o filtro digitado.
                    </Typography>
                  </Paper>
                ) : (
                  filteredItens.map((item) => {
                    const isExpanded = !!expandedItems[item.id_item];
                    const styleInfo = getStatusStyle(item.status_geral_instalacao);
                    const isMigrada = item.ultima_rv_detalhes && item.ultima_rv_detalhes.includes('migrada para outro CM');

                    return (
                      <Accordion
                        key={item.id_item}
                        expanded={isExpanded}
                        onChange={() => toggleAccordion(item.id_item)}
                        style={{
                          marginBottom: '12px',
                          borderRadius: '8px',
                          border: `2px solid ${styleInfo.borderColor}`
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: styleInfo.bgColor }}>
                          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                            <Grid item>
                              <Box display="flex" alignItems="center" gap={2}>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                                  Localidade: {item.nome_instalacao}
                                </Typography>
                                <Chip
                                  label={`ID SIGMA: ${item.identificador_integrador || 'N/A'}`}
                                  size="small"
                                  style={{ backgroundColor: '#e3f2fd', color: '#1565c0', fontWeight: 'bold' }}
                                />
                                {item.precisa_intervencao === 1 && (
                                  <Chip
                                    label="Intervenção Presencial Exigida"
                                    size="small"
                                    style={{ backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' }}
                                  />
                                )}
                              </Box>
                            </Grid>
                            <Grid item>
                              <Box display="flex" alignItems="center" gap={1} style={{ marginRight: 16 }}>
                                <Chip
                                  label={styleInfo.label}
                                  size="small"
                                  style={{ backgroundColor: styleInfo.chipBg, color: styleInfo.chipColor, fontWeight: 'bold' }}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionSummary>

                        <AccordionDetails style={{ padding: '24px', backgroundColor: '#fff' }}>
                          <Grid container spacing={3}>
                            {/* Painel Esquerdo: Dados Automáticos Capturados pelo Sistema */}
                            <Grid item xs={12} md={6}>
                              <Paper style={{ padding: '16px', backgroundColor: '#f9fbe7', borderLeft: '4px solid #827717' }}>
                                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#33691e', marginBottom: '12px' }}>
                                  📊 DADOS AUTOMÁTICOS CAPTURADOS DA LOCALIDADE
                                </Typography>

                                <Grid container spacing={1} style={{ marginBottom: '12px' }}>
                                  <Grid item xs={4}>
                                    <Typography variant="caption" color="textSecondary">PGMs / Unifiers</Typography>
                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>{item.qtd_pgm}</Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Typography variant="caption" color="textSecondary">Centrais de Alarme</Typography>
                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>{item.qtd_centrais}</Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Typography variant="caption" color="textSecondary">Cornetas</Typography>
                                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>{item.qtd_cornetas}</Typography>
                                  </Grid>
                                </Grid>

                                <Divider style={{ margin: '8px 0' }} />

                                <Typography variant="caption" color="textSecondary"><b>Endereçamento IP, PGM, Status Partições e Zonas:</b></Typography>
                                {renderDetalhesPgmCentrais(item.detalhes_pgm_centrais)}

                                <Divider style={{ margin: '12px 0' }} />

                                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#1b5e20', marginBottom: 4 }}>
                                  🛡️ ÚLTIMA RONDA VIRTUAL (HISTÓRICO COMPLETO)
                                </Typography>

                                {isMigrada && (
                                  <Paper style={{ padding: '8px 12px', backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 'bold', fontSize: '13px', marginBottom: 8, borderRadius: 6 }}>
                                    ⚠️ (Localidade não recebe mais Ronda Virtual, migrada para outro CM)
                                  </Paper>
                                )}

                                <Typography variant="body2"><b>Data/Hora:</b> {item.ultima_rv_data || 'N/A'}</Typography>
                                <Typography variant="body2"><b>Executor:</b> {item.ultima_rv_executor || '-'}</Typography>

                                <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: 'block' }}><b>Procedimentos Executados & Resultados:</b></Typography>
                                <Paper style={{ padding: '8px 12px', backgroundColor: '#fff', fontSize: '12px', whiteSpace: 'pre-wrap', maxHeight: '140px', overflowY: 'auto' }}>
                                  {item.ultima_rv_detalhes || 'Nenhum detalhe.'}
                                </Paper>

                                {item.ultima_rv_id && (
                                  <Box marginTop={2}>
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="primary"
                                      startIcon={<VisibilityIcon />}
                                      onClick={() => setSelectedRvModal(item)}
                                      style={{ backgroundColor: '#2e7d32' }}
                                    >
                                      Visualizar RV #{item.ultima_rv_id}
                                    </Button>
                                  </Box>
                                )}
                              </Paper>
                            </Grid>

                            {/* Painel Direito: Campos Manuais Preenchidos pelo Auditado */}
                            <Grid item xs={12} md={6}>
                              <Paper style={{ padding: '16px', backgroundColor: '#fafafa', borderLeft: '4px solid #1976d2' }}>
                                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#0d47a1', marginBottom: '16px' }}>
                                  ✍️ CAMPOS MANUAIS DA AUDITORIA
                                </Typography>

                                <Grid container spacing={2}>
                                  {/* Marcação de Intervenção Presencial */}
                                  <Grid item xs={12}>
                                    <Paper style={{ padding: '12px', backgroundColor: item.precisa_intervencao === 1 ? '#ffebee' : '#f1f8e9', borderRadius: 8 }}>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={item.precisa_intervencao === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'precisa_intervencao', e.target.checked)}
                                            color="secondary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label={
                                          <Typography variant="body1" style={{ fontWeight: 'bold', color: item.precisa_intervencao === 1 ? '#c62828' : '#2e7d32' }}>
                                            Necessita Intervenção Presencial na Localidade: {item.precisa_intervencao === 1 ? 'SIM' : 'NÃO'}
                                          </Typography>
                                        }
                                      />
                                    </Paper>
                                  </Grid>

                                  {/* Status da Corneta 1 & 2 */}
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Status da Corneta 1</InputLabel>
                                      <Select
                                        value={item.status_corneta_1 || 'Online'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_corneta_1', e.target.value)}
                                        label="Status da Corneta 1"
                                      >
                                        <MenuItem value="Online">Online</MenuItem>
                                        <MenuItem value="Offline">Offline</MenuItem>
                                        <MenuItem value="Sem Ramal">Sem Ramal</MenuItem>
                                        <MenuItem value="Chamada não completa">Chamada não completa</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Status da Corneta 2</InputLabel>
                                      <Select
                                        value={item.status_corneta_2 || 'Não se aplica'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_corneta_2', e.target.value)}
                                        label="Status da Corneta 2"
                                      >
                                        <MenuItem value="Online">Online</MenuItem>
                                        <MenuItem value="Offline">Offline</MenuItem>
                                        <MenuItem value="Sem Ramal">Sem Ramal</MenuItem>
                                        <MenuItem value="Chamada não completa">Chamada não completa</MenuItem>
                                        <MenuItem value="Não se aplica">Não se aplica</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Conexão PGM x Central 1 & 2 */}
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Conexão PGM x Central 1</InputLabel>
                                      <Select
                                        value={item.status_conexao_pgm_central_1 || 'Conectado'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_conexao_pgm_central_1', e.target.value)}
                                        label="Conexão PGM x Central 1"
                                      >
                                        <MenuItem value="Conectado">Conectado</MenuItem>
                                        <MenuItem value="Desconectado">Desconectado</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Conexão PGM x Central 2</InputLabel>
                                      <Select
                                        value={item.status_conexao_pgm_central_2 || 'Não se aplica'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_conexao_pgm_central_2', e.target.value)}
                                        label="Conexão PGM x Central 2"
                                      >
                                        <MenuItem value="Conectado">Conectado</MenuItem>
                                        <MenuItem value="Desconectado">Desconectado</MenuItem>
                                        <MenuItem value="Não se aplica">Não se aplica</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Conexão PGM x Corneta 1 & 2 */}
                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Conexão PGM x Corneta 1</InputLabel>
                                      <Select
                                        value={item.status_conexao_pgm_corneta_1 || 'Conectado'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_conexao_pgm_corneta_1', e.target.value)}
                                        label="Conexão PGM x Corneta 1"
                                      >
                                        <MenuItem value="Conectado">Conectado</MenuItem>
                                        <MenuItem value="Desconectado">Desconectado</MenuItem>
                                        <MenuItem value="Não se aplica">Não se aplica</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!canEdit}>
                                      <InputLabel>Conexão PGM x Corneta 2</InputLabel>
                                      <Select
                                        value={item.status_conexao_pgm_corneta_2 || 'Não se aplica'}
                                        onChange={(e) => handleFieldChange(item.id_item, 'status_conexao_pgm_corneta_2', e.target.value)}
                                        label="Conexão PGM x Corneta 2"
                                      >
                                        <MenuItem value="Conectado">Conectado</MenuItem>
                                        <MenuItem value="Desconectado">Desconectado</MenuItem>
                                        <MenuItem value="Não se aplica">Não se aplica</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Observações e Firmware da PGM */}
                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={2}
                                      variant="outlined"
                                      label="Observações Gerais sobre a PGM"
                                      placeholder="Ex: PGM modelo 2023..."
                                      value={item.observacao_pgm || ''}
                                      onChange={(e) => handleFieldChange(item.id_item, 'observacao_pgm', e.target.value)}
                                      disabled={!canEdit}
                                    />
                                    <Box display="flex" gap={2} marginTop={1}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={item.atualiza_via_rede === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'atualiza_via_rede', e.target.checked)}
                                            color="primary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label="Atualiza via Rede"
                                      />
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={item.atualiza_via_usb === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'atualiza_via_usb', e.target.checked)}
                                            color="secondary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label="Somente atualiza via USB (visita presencial)"
                                      />
                                    </Box>
                                  </Grid>

                                  {/* Observações da Corneta */}
                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={2}
                                      variant="outlined"
                                      label="Observações Gerais sobre a Corneta"
                                      placeholder="Ex: Corneta com volume baixo..."
                                      value={item.observacao_corneta || ''}
                                      onChange={(e) => handleFieldChange(item.id_item, 'observacao_corneta', e.target.value)}
                                      disabled={!canEdit}
                                    />
                                  </Grid>

                                  <Grid item xs={12}>
                                    <Divider style={{ margin: '8px 0' }} />
                                    <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#1a237e', marginBottom: 8 }}>
                                      📋 RESOLUTIVA DA AUDITORIA
                                    </Typography>
                                    <Box display="flex" flexDirection="column" gap={0.5} marginBottom={1}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={item.resolutiva_remoto_se_aplica === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'resolutiva_remoto_se_aplica', e.target.checked)}
                                            color="primary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label="Tentativa de Tratamento Remoto Se Aplica"
                                      />
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={item.resolutiva_remoto_nao_se_aplica === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'resolutiva_remoto_nao_se_aplica', e.target.checked)}
                                            color="primary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label="Tentativa de Tratamento Remoto Não Se Aplica"
                                      />
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={item.resolutiva_visita_presencial === 1}
                                            onChange={(e) => handleCheckboxChange(item.id_item, 'resolutiva_visita_presencial', e.target.checked)}
                                            color="secondary"
                                            disabled={!canEdit}
                                          />
                                        }
                                        label="Necessita Visita Presencial"
                                      />
                                    </Box>

                                    <TextField
                                      fullWidth
                                      multiline
                                      rows={3}
                                      variant="outlined"
                                      label="Observações da Resolutiva"
                                      placeholder="Ex: Agendada visita presencial para dia..."
                                      value={item.resolutiva || ''}
                                      onChange={(e) => handleFieldChange(item.id_item, 'resolutiva', e.target.value)}
                                      disabled={!canEdit}
                                    />
                                  </Grid>
                                </Grid>
                              </Paper>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                )}
              </div>
            )}
          </>
        )}
      </Container>

      {/* Modal Confirmar Finalizar Auditoria */}
      <Dialog open={openFinalizarDialog} onClose={() => setOpenFinalizarDialog(false)}>
        <DialogTitle>Finalizar Auditoria de Monitoramento?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Atenção: Ao finalizar a auditoria, o status será alterado para <b>Finalizada</b> e todos os campos ficarão bloqueados para edições futuras.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '16px' }}>
          <Button onClick={() => setOpenFinalizarDialog(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleFinalizarAuditoria} variant="contained" style={{ backgroundColor: '#2e7d32', color: '#fff' }}>
            Confirmar e Finalizar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Visualizar Detalhes da RV */}
      <Dialog open={!!selectedRvModal} onClose={() => setSelectedRvModal(null)} maxWidth="md" fullWidth>
        <DialogTitle>Visualizar Ronda Virtual (RV #{selectedRvModal?.ultima_rv_id})</DialogTitle>
        <DialogContent dividers>
          {selectedRvModal && (
            <div>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                Localidade: {selectedRvModal.nome_instalacao} (ID SIGMA: {selectedRvModal.identificador_integrador})
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Data/Hora Conclusão: <b>{selectedRvModal.ultima_rv_data}</b> | Executor: <b>{selectedRvModal.ultima_rv_executor}</b>
              </Typography>
              <Divider style={{ margin: '16px 0' }} />
              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#2e7d32', marginBottom: 8 }}>
                Procedimentos Executados & Resultados Registrados:
              </Typography>
              <Paper style={{ padding: '16px', backgroundColor: '#f5f5f5', whiteSpace: 'pre-wrap', fontFamily: 'sans-serif' }}>
                {selectedRvModal.ultima_rv_detalhes || 'Nenhum procedimento detalhado registrado.'}
              </Paper>
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px' }}>
          <Button onClick={() => setSelectedRvModal(null)} color="primary" variant="contained">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
